import { createAction, props } from '@ngrx/store';
import { ContestRequest } from './contest.state';

export const insertRequest = createAction('[Contest] Insert Request', props<{ request: ContestRequest }>());
